<template>
  <div id="app">
    <nav-header></nav-header>
    <router-view v-if="isRouterAlive" :key="this.$route.path"></router-view>
    <Footer></Footer>
    <!-- 回到顶部 -->
    <el-backtop :bottom="160" :right="10">
      <div class="back-top-div" title="回到顶部">
        <i class="el-icon-arrow-up font-weight-bold"></i>
        <div>
          TOP
        </div>
      </div>
    </el-backtop>
  </div>
</template>
<script>
import NavHeader from "./components/common/NavHeader";
import Footer from "./components/common/Footer";

export default {
  name: "Home",
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    NavHeader,
    Footer
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-size: 14px;

  a {
    text-decoration: none;
  }

  .back-top-div {
    width: 100%;
    height: 45px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
    text-align: center;
    font-size: 13px;
    color: #ff530a;
  }
}
</style>
